import React from "react";
import { 
  DashboardHeader as StyledDashboardHeader
 } from './DashboardHeader.styles';

const DashboardHeader =() =>{ 
  return(
      <StyledDashboardHeader>
          My Recent Tenders
      </StyledDashboardHeader>
  )
}

export default DashboardHeader;